import { useGetThemeMessagesQuery } from '@/store/api/chat.api';
import { LoadingOutlined } from '@ant-design/icons';
import { format } from 'date-fns';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import styles from './SupportChat.module.scss';

const SupportTheme: React.FC = () => {
  const { data: themeMessages, isLoading: loadingThemeMessages } =
    useGetThemeMessagesQuery({});
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      {loadingThemeMessages && (
        <div className={styles.loader}>
          <LoadingOutlined />
        </div>
      )}

      {themeMessages?.themes.map((theme) => (
        <div
          key={theme.id}
          className={styles.themeMessage}
          onClick={() => navigate(`/support-chat/${theme.id}`)}
          style={{ cursor: 'pointer' }}
        >
          <div>
            <span className={styles['themeMessage-date']}>
              {format(new Date(theme.date), 'dd.MM.yyyy')}
              {' -- '}
              {format(new Date(theme.date), 'HH:mm:ss')}
            </span>{' '}
            <h3 className={styles['themeMessage-title']}>
              <span>Тема:</span> {theme.name}
            </h3>
          </div>

          <div className={styles['themeMessage-tag']}>
            {theme.status && (
              <span className={styles['themeMessage-tag-important']}>
                Важно!
              </span>
            )}
            {theme.new !== 0 && (
              <span className={styles['themeMessage-tag-new']}>
                {/* Новых сообщений: {theme.new} */}
                Новое
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SupportTheme;
